import type { Booking, ClientGallery, Review } from '../types';
import { demoStore } from './store';

const demoMode = import.meta.env.VITE_DEMO_MODE !== 'false';

export async function lookupGallery(galleryId: string, pin?: string): Promise<ClientGallery | null> {
  if (demoMode) return demoStore.getGallery(galleryId.trim(), pin?.trim());
  const res = await fetch('/.netlify/functions/gallery-access', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ galleryId, pin }) });
  if (!res.ok) return null;
  return res.json();
}

export async function saveSelection(galleryId: string, selectedIds: string[]) {
  if (demoMode) return demoStore.updateSelections(galleryId, selectedIds);
  const res = await fetch('/.netlify/functions/gallery-selection', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ galleryId, selectedIds, action: 'save' }) });
  if (!res.ok) throw new Error('Could not save selection');
  return res.json();
}

export async function submitSelection(galleryId: string, selectedIds: string[]) {
  if (demoMode) { demoStore.updateSelections(galleryId, selectedIds); return demoStore.submitSelection(galleryId); }
  const res = await fetch('/.netlify/functions/gallery-selection', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ galleryId, selectedIds, action: 'submit' }) });
  if (!res.ok) throw new Error('Could not submit selection');
  return res.json();
}

export async function reportPayment(galleryId: string) {
  if (demoMode) return demoStore.reportPayment(galleryId);
  const res = await fetch('/.netlify/functions/gallery-payment', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ galleryId }) });
  if (!res.ok) throw new Error('Could not report payment');
  return res.json();
}

export async function createBooking(booking: Booking) {
  if (demoMode) { demoStore.addBooking(booking); return booking; }
  const res = await fetch('/.netlify/functions/booking-create', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(booking) });
  if (!res.ok) throw new Error('Could not create booking');
  return res.json();
}

export async function adminLogin(password: string) {
  const res = await fetch('/.netlify/functions/admin-login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'include', body: JSON.stringify({ password }) });
  return res.ok;
}

export async function adminLogout() {
  await fetch('/.netlify/functions/admin-logout', { method: 'POST', credentials: 'include' });
}

export async function createReview(review: Review, galleryId: string) {
  if (demoMode) { demoStore.addReview(review); return review; }
  const res = await fetch('/.netlify/functions/review-create', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...review, galleryId }) });
  if (!res.ok) throw new Error('Could not submit review');
  return res.json();
}
